import React, { useEffect, useMemo, useRef, useState } from "react";
import styles from "./ConfirmExportToExcelModal.module.css";
import { Button, Col, Modal, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import Select, { StylesConfig, type CSSObjectWithLabel } from "react-select";
import { CustomButton } from "../../../../reusable-components/CustomButtonComponent/button";
import * as Icon from "react-bootstrap-icons";
import { downloadWorksheet, exportToExcel, exportToPDF, getAllWorksheetsData } from "./ConfirmExportToExcelModal.service";
import CygnusGrid from "pages/CygnusGrid/CygnusGrid";
import { CreatedDateRenderer } from "pages/K1/K1LandingPage/K1HelperFunctions";
import RefreshButton from "reusable-components/CustomButtonComponent/RefreshButton";

/**
 * ConfirmExportToExcelModal Component
 */
const ConfirmExportToExcelModal: React.FC<any> = ({
  show,
  onHide,
  refresh,
  selectedrows,
  returnid,
  clientmasterid,
  importtotaxflag,
  internalk1activities
}) => {
  const [importToTaxConfirmFlag, setImportToTaxConfirmFlag] = useState(false);
  const [downloadMergedPdfFlag, setDownloadMergedPdfFlag] = useState(false);
  const gridStyle = useMemo(() => ({ height: "300px", minHeight: "100%", width: "100%" }), []);
  const [rowData, setRowData] = useState<any[]>([]);
  const [refreshGrid, setRefreshGrid] = useState(false);
  const gridRef = useRef(null);
  const [excelExportOptions, setExcelExportOptions] = useState<any[]>([
    { value: "cygnusdefault", label: "Cygnus Default" },
    { value: "cchsupported", label: "CCH Supported" },
    { value: "custom", label: "My Template" },
  ]);

  const [key, setKey] = useState<number | undefined>(undefined);

  const [selectedExcelExportOption, setSelectedExcelExportOption] = useState<any>({
  value: "cygnusdefault",
  label: "Cygnus Default"
});
  type OptionType = { label: string; value: string };
  const customStyles: StylesConfig<OptionType, false> = {
    control: (base) => ({
      ...base,
      fontSize: "12px",
      minHeight: "32px",
    }) as CSSObjectWithLabel,
    singleValue: (base) => ({
      ...base,
      fontSize: "12px",
    }) as CSSObjectWithLabel,
    option: (base) => ({
      ...base,
      fontSize: "12px",
    }) as CSSObjectWithLabel,
    placeholder: (base) => ({
      ...base,
      fontSize: "12px",
    }) as CSSObjectWithLabel,
  };



  const ExportCellRenderer = (props: any) => {

    const downloadExcelWorksheet = async () => {
      // console.log(props)
      const blob = await downloadWorksheet(props.data.ActivityId);
      const href = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = href;
      link.setAttribute('download', `${props.data.BlobFileName}`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    return (
      <>
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={
            <Tooltip id="button-tooltip">Download Document</Tooltip>
          }
        // error={true}          
        >
          <div className={styles.tooltipWrapper}>
            <Button
              className={styles.actionButton}
              style={{
                color: "var(--theme1_primary)",
                pointerEvents: "all",
              }}
              onClick={() => downloadExcelWorksheet()}>
              <Icon.Download className={styles.iconsmall}
                style={{
                  color: "var(--theme1_primary)",
                  opacity: "1"
                }}
              />
            </Button>
          </div>
        </OverlayTrigger>
      </>
    )
  }

  const confirmModalColdefs: any = [
    {
      headerName: "File",
      field: "BlobFileName",
      flex: 2,
      sortable: false
    },
    {
      headerName: "Status",
      field: "Status",
      flex: 1,
    },
    {
      headerName: "Created Date",
      field: "CreatedDate",
      flex: 1,
      cellRenderer: (params: any) => CreatedDateRenderer(params.data.CreatedDate)
    },
    {
      headerName: "Action",
      field: "",
      cellRenderer: ExportCellRenderer,
      pinned: "right",
      maxWidth: 120,
      minWidth: 120,
      sortable: false
    },
  ]

  const [colDefs, setColDefs] = useState(confirmModalColdefs);

  useEffect(() => {
    getAllWorksheets();
    console.log(internalk1activities);
    if (internalk1activities && internalk1activities[0]) {
      internalk1activities[0].Mappings.forEach((item: any) => {
        if (item.ChildActivityNumber.includes("_temp")) {
          item.ChildActivityNumber = "";
        }
      });
    }
  }, [])

  const getAllWorksheets = async () => {
    setRefreshGrid(true)
    const data = await getAllWorksheetsData(returnid?.value);
    setRowData(data.data)
    setKey(data.data.length)
    setRefreshGrid(false)
  }

  const confirmImportToTax = async () => {
    setImportToTaxConfirmFlag(true)
    const selectedRowPayload = selectedrows.map((item: any) => ({
      DocumentId: item.DocumentId,
      SourceName: item.SourceName,
      DocumentType: item.DocumentType,
      InternalK1SelectedReturnId: item.DocumentType === "Internal Schedule K-1" ? item.InternalK1SelectedReturnId : ""
    }))
    const payload = {
      "ClientMasterId": clientmasterid,
      "SelectedReturn": returnid?.value,
      "SelectedRows": selectedRowPayload,
      "ExportAs": selectedExcelExportOption?.value || "cygnusdefault",
      "InternalK1Activities": internalk1activities
    }
    const response = await exportToExcel(payload);
    setImportToTaxConfirmFlag(false)
    // Assume response is a Blob
    // const blob = response; // Already a Blob object

    // // Create a URL from the blob
    // const url = window.URL.createObjectURL(blob);

    // // Create a temporary <a> element
    // const a = document.createElement('a');
    // a.href = url;

    // // Optionally set the filename
    // a.download = (returnid?.value?.trim() || "exported documents") + ".xlsx"; // <-- change as needed

    // // Append to body (needed for Firefox sometimes)
    // document.body.appendChild(a);

    // // Trigger the download
    // a.click();

    // // Cleanup
    // a.remove();
    // window.URL.revokeObjectURL(url);
  }

  const downloadMergedPdf = async () => {
    setDownloadMergedPdfFlag(true)
    const selectedRowPayload = selectedrows.map((item: any) => ({
      DocumentId: item.DocumentId,
      SourceName: item.SourceName,
      DocumentType: item.DocumentType,
      InternalK1SelectedReturnId: item.DocumentType === "Internal Schedule K-1" ? item.InternalK1SelectedReturnId : ""
    }))
    const payload = {
      "ClientMasterId": clientmasterid,
      "SelectedReturn": returnid?.value,
      "SelectedRows": selectedRowPayload
    }

    const response = await exportToPDF(payload);
    setDownloadMergedPdfFlag(false)
    // Assume response is a Blob
    const blob = response; // Already a Blob object

    // Create a URL from the blob
    const url = window.URL.createObjectURL(blob);

    // Create a temporary <a> element
    const a = document.createElement('a');
    a.href = url;

    // Optionally set the filename
    a.download = (returnid?.value?.trim() || "exported documents") + ".pdf"; // <-- change as needed

    // Append to body (needed for Firefox sometimes)
    document.body.appendChild(a);

    // Trigger the download
    a.click();

    // Cleanup
    a.remove();
    window.URL.revokeObjectURL(url);
  }

  const handleClose = () => {
    importtotaxflag();
    onHide();
  }

  const onExcelExportOptionChange = (selectedOption: any) => {
    setSelectedExcelExportOption(selectedOption);
  }

  return (
    <>
      <div
        className={styles.modaloverlay}
      />
      <Modal
        show={show}
        onHide={() => handleClose}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        backdrop="static"
        centered
        className={styles.wholeClass}
        contentClassName={styles.confirmModal}
        scrollable={false}
      >
        <Modal.Header style={{ paddingBottom: 5 }}>
          <div>
            <h4 className={styles.header}>&nbsp;Exporting these documents.</h4>
            <span className={styles.internalK1Note}>Note: Internal K1 would not get exported to excel or pdf.</span>
          </div>
          <button
            type="button"
            className={styles.closeButton}
            onClick={handleClose}
            aria-label="Close"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </button>
        </Modal.Header>
        <Modal.Body className={styles.modalBody}>
          <Row>
            <Col md={8}>
              <span style={{ marginLeft: 10, fontSize: 13 }}>
                Return Id - <strong>{returnid?.value}</strong>
              </span>
            </Col>
            <Col md={4}>
              <RefreshButton
                refreshflag={refreshGrid}
                refreshfunction={() => getAllWorksheets()}
              />
            </Col>

          </Row>
          <Row className="no-gutter" style={{ marginTop: 10, marginBottom: 10 }}>
            <Col md={12}>
              <div style={gridStyle}>
                <CygnusGrid
                  key={key}
                  ref={gridRef}
                  columnDefs={colDefs}
                  fetchData={async () => {
                    // Since this is not paginated, just return everything
                    return { records: rowData, totalCount: rowData.length };
                  }}
                  dataIdentifier="ActivityId"
                  rowSelection={"single"}
                  onLoadingChange={setRefreshGrid}
                  cachedIsLoading={refreshGrid}
                  cachedData={rowData}
                  setCachedData={setRowData}
                  rowModelType="clientSide"
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <div className="d-flex justify-content-start border-end pe-4">
                <CustomButton
                  progress={downloadMergedPdfFlag}
                  onclick={() => downloadMergedPdf()}
                  content={downloadMergedPdfFlag ? "Preparing pdf..." : "Download PDF"}
                  disable={downloadMergedPdfFlag}
                  icon={<Icon.FilePdf size={16} />}
                />
              </div>
            </Col>
            {/* Vertical separator */}
            <Col md={6} className="d-flex justify-content-end gap-2 ps-4">
              <div style={{ width: 180 }}>
                <Select
                  onChange={onExcelExportOptionChange}
                  value={selectedExcelExportOption}
                  placeholder={<div>Select Option</div>}
                  options={excelExportOptions}
                  classNamePrefix="react-select"
                  styles={customStyles}
                />
              </div>

              <CustomButton
                progress={importToTaxConfirmFlag}
                onclick={confirmImportToTax}
                content={importToTaxConfirmFlag ? "Generating Worksheet..." : "Generate Worksheet"}
                disable={importToTaxConfirmFlag}
                icon={<Icon.FileExcel size={16} />}
              />
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ConfirmExportToExcelModal;
